var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout"},[_c('el-header',{staticStyle:{"height":"315px"}},[_c('header-vue')],1),_c('el-main',[_c('router-view')],1),_c('el-footer',[_c('footer-vue')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }